import React from 'react';
import './Manufacturing.css';

const steps = [
  { id: 1,  title: 'Mixing',      desc: 'Raw material preparation and mixing',                icon: 'fas fa-cogs' },
  { id: 2,  title: 'Extrusion',    desc: 'Tape extrusion using 2 LOHIA Dueotec Plants',      icon: 'fas fa-industry' },
  { id: 3,  title: 'Weaving',      desc: 'Utilizes 89 LOHIA Looms for fabric production',    icon: 'fas fa-th' },
  { id: 4,  title: 'Lamination',   desc: 'Film lamination process',                          icon: 'fas fa-layer-group' },
  { id: 5,  title: 'Cutting',      desc: 'Precision cutting to specifications',              icon: 'fas fa-cut' },
  { id: 6,  title: 'Printing',     desc: 'High-end ROTO-8COL ZOOM BOPP Printing Machine',   icon: 'fas fa-print' },
  { id: 7,  title: 'Webbing',      desc: 'Webbing and reinforcement',                        icon: 'fas fa-link' },
  { id: 8,  title: 'Sewing',       desc: 'Stitching and assembly',                           icon: 'fas fa-scissors' },
  { id: 9,  title: 'Testing',      desc: 'Quality control and testing',                      icon: 'fas fa-vial' },
  { id: 10, title: 'Baling',       desc: 'Packaging and baling',                             icon: 'fas fa-box' },
  { id: 11, title: 'Dispatch',     desc: 'Final dispatch and delivery',                      icon: 'fas fa-truck' }
];

export default function Manufacturing() {
  return (
    <section id="manufacturing" className="manufacturing section">
      <div className="container">
        <div className="section-header text-center">
          <h2 className="section-title">Manufacturing Process</h2>
          <p className="section-subtitle">From raw materials to dispatch, step by step.</p>
        </div>

        <div className="process-flow">
          {steps.map((s, idx) => (
            <div key={s.id} className="process-step">
              <div className="step-card">
                <div className="step-number-badge">
                  <div className="step-number">{s.id}</div>
                </div>
                <div className="step-content-wrapper">
                  <div className="step-header">
                    <div className="step-icon"><i className={s.icon}></i></div>
                    <h3 className="step-title">{s.title}</h3>
                  </div>
                  <p className="step-description">{s.desc}</p>
                </div>
              </div>
              {idx < steps.length - 1 && (
                <div className="step-connector">
                  <div className="connector-line"></div>
                  <div className="connector-arrow"></div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
